import { render, staticRenderFns } from "./ChickenDetail.vue?vue&type=template&id=edfcb39e&scoped=true&"
import script from "./ChickenDetail.vue?vue&type=script&lang=js&"
export * from "./ChickenDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChickenDetail.vue?vue&type=style&index=0&id=edfcb39e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfcb39e",
  null
  
)

export default component.exports